import { useContext } from "react";
import { TemplateOptions } from "@coxauto-ui/cxm/communications/api";
import {
  ConversationDetailsContext,
  useEmailReply,
  useTextReply
} from "../../context";
import { ConversationTypeEnum } from "@coxauto-ui/cxm/communications/interfaces";
import { BaseTemplateSelectorModal } from "./base-template-selector-modal";

interface TemplateSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  templateData: TemplateOptions;
  onTemplateSelect?: (templateId: number, isTemplateGenAI: boolean) => void;
  isLoading?: boolean;
  isInsertingTemplate?: boolean;
}

/**
 * Smart template selector modal that automatically routes to the correct context
 * based on the current conversation type (email or text).
 */
export function TemplateSelectorModal(props: TemplateSelectorModalProps) {
  const { currentConversationType } = useContext(ConversationDetailsContext);
  const emailReply = useEmailReply();
  const textReply = useTextReply();
  if (currentConversationType === ConversationTypeEnum.PHONE) {
    return null;
  }
  const isEmail = currentConversationType === ConversationTypeEnum.EMAIL;

  return (
    <BaseTemplateSelectorModal
      {...props}
      replyText={isEmail ? emailReply.replyText : textReply.replyText}
      replyTextSubject={isEmail ? emailReply.replyTextSubject : undefined}
    />
  );
}

export default TemplateSelectorModal;
